import type { AdminQuoteDetail } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/**
 * 캐시에 있는 견적 상세(quoteManagement.get)를 읽는다 — 요청을 보내지 않는다.
 * 뮤테이션이 invalidate 로 재조회를 기다린 뒤 방금 받은 상세를 확인할 때 쓴다(초안 동시성 토큰 이어받기).
 */
export const useCachedQuoteDetail = (): ((
  quoteRequestId: string,
) => AdminQuoteDetail | undefined) => {
  const utils = trpc.useUtils();
  return (quoteRequestId) => utils.quoteManagement.get.getData({ quoteRequestId });
};
